// AUTO-GENERATED by scripts/generate-content-meta.ts — do not edit by hand.
// Source of truth: src/features/news/content/<locale>/*.ts. Deliberately excludes
// blocks[] (the article body) — see registry.ts for why that stays a lazy per-file import.
import type { NewsMeta } from "@/features/news/types";
import type { Locale } from "@/lib/i18n/config";

export const NEWS_META: Partial<Record<Locale, Record<string, NewsMeta>>> = {
  "en": {
    "bubbles-day-14-locations": {
      "id": "bubbles-day-14-locations",
      "category": "event",
      "date": "2026-02-14",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubble14/bubble-1-loc.webp",
      "title": "Heartopia Day 14 Bubble Locations (14 bubbles with minimap photos)",
      "excerpt": "All 14 Day 14 bubble locations in Heartopia with two images per bubble: a close-up (bubble) + a minimap photo (location). No coordinates shown, just visual references for fast routing.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap",
        "day 14"
      ]
    },
    "bubbles-day-7-locations": {
      "id": "bubbles-day-7-locations",
      "category": "event",
      "date": "2026-02-07",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubblesFeb/bubble-7.webp",
      "title": "Heartopia Day 7 Bubble Locations (14 bubbles with minimaps)",
      "excerpt": "All 14 Day 7 bubble locations in Heartopia with an image + minimap per bubble, plus a final full map. Coordinates are hidden (used only for map markers).",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap"
      ]
    },
    "dreamlight-cinematics-festival": {
      "id": "dreamlight-cinematics-festival",
      "category": "event",
      "date": "2026-03-21",
      "readTimeMinutes": 6,
      "color": "from-amber-500 to-rose-600",
      "featured": true,
      "bannerImage": "/events/dreamlight-cinematics/dreamlight-cinematics-week.webp",
      "title": "Dreamlight Cinematics Festival in Heartopia: dates, Azure store, catalog, Saxophone, and what to do first",
      "excerpt": "Dreamlight Cinematics Festival is live in Heartopia from March 21 to May 2, 2026. The current seasonal event brings the Dreamlight Cinematics Catalog, Festival Store run by Azure, Festival Packs, Saxophone, limited cooking content, and phased fish, insects, birds, and wild greens.",
      "author": "amayacrab",
      "tags": [
        "event",
        "dreamlight cinematics festival",
        "azure",
        "massimo",
        "saxophone",
        "limited recipes"
      ]
    },
    "heartopia-30-million-downloads": {
      "id": "heartopia-30-million-downloads",
      "category": "news",
      "date": "2026-04-03",
      "readTimeMinutes": 3,
      "color": "from-emerald-500 to-teal-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Heartopia hits 30 million downloads — free celebration gift package explained",
      "excerpt": "Heartopia announced 30 million worldwide downloads on April 3–4, 2026, with a free celebration gift package claimable until May 29: a 30M Celebration Balloon, Wishing Stars, Roaming Oak Timber, Flawless Fluorite, and Mermaid Fish Attractors.",
      "author": "amayacrab",
      "tags": [
        "news",
        "milestone",
        "30 million downloads",
        "free rewards"
      ]
    },
    "heartopia-building-contest-phase-1-winter-frost-home": {
      "id": "heartopia-building-contest-phase-1-winter-frost-home",
      "category": "event",
      "date": "2026-01-30",
      "readTimeMinutes": 5,
      "color": "from-purple-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Heartopia Building Contest (Phase 1): Winter Frost Home — how to enter, rules, and rewards",
      "excerpt": "Heartopia Building Contest (Phase 1) is live with the Winter Frost Home theme. Post a 1–2 minute video with your Player ID visible in the official Discord between Jan 30 and Feb 7 for a chance to win a physical Meow-Meow Blind Box.",
      "author": "amayacrab",
      "tags": [
        "event",
        "contest",
        "building",
        "discord",
        "winter-frost-home",
        "limited-time"
      ]
    },
    "heartopia-butterbear-collaboration": {
      "id": "heartopia-butterbear-collaboration",
      "category": "event",
      "date": "2026-06-06",
      "readTimeMinutes": 4,
      "color": "from-amber-400 to-orange-600",
      "bannerImage": "/icons/misc/cooking-misc-hobby.webp",
      "title": "Heartopia × Butterbear collaboration: bakery decor, cookies, and the diner bear cart",
      "excerpt": "Heartopia × Butterbear ran June 6–27, 2026, bringing bakery-themed furniture, two Gilded Acorn Exhibition banners (\"The Baker,\" \"Flavor Explorer\"), and a rideable diner bear cart vehicle — clearing the full shop reportedly took 7,000+ cookies.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "butterbear",
        "gilded acorn exhibition",
        "vehicles"
      ]
    },
    "heartopia-easter-egg-pact-2026": {
      "id": "heartopia-easter-egg-pact-2026",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 6,
      "color": "from-rose-400 to-amber-500",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "Heartopia \"My Easter Egg Pact\": Revival Hymn and Wonder Egg Hunt guide",
      "excerpt": "Heartopia's Easter season, \"My Easter Egg Pact,\" ran April 4–27, 2026 with two events at once: Revival Hymn (gathering-based currency and recipes) and Wonder Egg Hunt (photograph 8 hidden eggs in Central Square for ornament rewards).",
      "author": "amayacrab",
      "tags": [
        "event",
        "easter",
        "revival hymn",
        "wonder egg hunt",
        "limited recipes"
      ]
    },
    "heartopia-midsummer-rhyme-dragon-boat": {
      "id": "heartopia-midsummer-rhyme-dragon-boat",
      "category": "event",
      "date": "2026-06-19",
      "readTimeMinutes": 4,
      "color": "from-emerald-600 to-lime-500",
      "bannerImage": "/events/repeatable/start-sea-fishing.webp",
      "title": "Heartopia \"Midsummer Rhyme\" and the Dryland Dragon Boat Challenge minigame",
      "excerpt": "Heartopia's Dragon Boat Festival tie-in, \"Midsummer Rhyme,\" started June 19, 2026 with daily requests for Astralis's Mugwort Leaves and a new Dryland Dragon Boat Challenge minigame — paddle with a partner who drums to restore your energy.",
      "author": "amayacrab",
      "tags": [
        "event",
        "midsummer rhyme",
        "dragon boat festival",
        "minigame",
        "astralis"
      ]
    },
    "heartopia-modular-streets-festival": {
      "id": "heartopia-modular-streets-festival",
      "category": "event",
      "date": "2026-05-09",
      "readTimeMinutes": 5,
      "color": "from-orange-500 to-red-600",
      "bannerImage": "/events/repeatable/bait-the-insects-banner.webp",
      "title": "Heartopia Modular Streets Festival: how to unlock brick-variant fish, insects, and recipes",
      "excerpt": "The LEGO-style Modular Streets Festival ran in Heartopia from May 9 to June 19, 2026 — six weeks of brick-variant fish, insects, and birds, plus new Brick-themed recipes, unlocked by catching a Damselfly and bringing it to Azure.",
      "author": "amayacrab",
      "tags": [
        "event",
        "modular streets festival",
        "azure",
        "limited recipes",
        "damselfly"
      ]
    },
    "heartopia-oceanbound-call-of-whales-update": {
      "id": "heartopia-oceanbound-call-of-whales-update",
      "category": "update",
      "date": "2026-07-04",
      "readTimeMinutes": 7,
      "color": "from-sky-500 to-blue-700",
      "featured": true,
      "bannerImage": "/locations/whale-mountain.webp",
      "title": "Heartopia 2.7 \"Oceanbound\" / Call of Whales: Whale Canyon, Ocean Cleanup, Seamount housing, and Rory",
      "excerpt": "Heartopia's half-anniversary update, version 2.7 \"Oceanbound\" (Fashionwave: Call of Whales), rolled out from July 4, 2026 with the main content — new map Whale Canyon, the Ocean Cleanup hobby, Seamount underwater housing, and new NPC Rory — releasing July 11 through August 22.",
      "author": "amayacrab",
      "tags": [
        "update",
        "oceanbound",
        "call of whales",
        "whale canyon",
        "ocean cleanup",
        "seamount",
        "rory"
      ]
    },
    "heartopia-pets-showcase-x-event-2026": {
      "id": "heartopia-pets-showcase-x-event-2026",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 4,
      "color": "from-pink-500 to-rose-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Heartopia Pets Event on X: how to join, rules, dates, and rewards (Feb 2–Feb 8)",
      "excerpt": "Heartopia's pet sharing event is live on X: post photos/videos of your pet (in-game or real-life), use #heartopia, and quote/repost the official post by Feb 8. Three D.G. Members will each receive a Meow-Meow Blind Box.",
      "author": "amayacrab",
      "tags": [
        "event",
        "giveaway",
        "pets",
        "social",
        "x",
        "limited-time",
        "dg-members"
      ]
    },
    "heartopia-sanrio-characters-collaboration": {
      "id": "heartopia-sanrio-characters-collaboration",
      "category": "event",
      "date": "2026-07-17",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × SANRIO CHARACTERS \"Wonderland\": Cinnamoroll, Kuromi, My Melody, and the gacha machine",
      "excerpt": "Heartopia × SANRIO CHARACTERS' \"Wonderland\" started July 17, 2026, featuring Cinnamoroll, Kuromi, and My Melody through a Speciality Exhibition, a Furniture Fair, a player-placed gacha machine (up to 5 spins/day), and daily sticker quests.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "sanrio",
        "cinnamoroll",
        "kuromi",
        "my melody",
        "gacha"
      ]
    },
    "heartopia-shape-of-you-mbti-event": {
      "id": "heartopia-shape-of-you-mbti-event",
      "category": "event",
      "date": "2026-03-13",
      "readTimeMinutes": 5,
      "color": "from-violet-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Heartopia \"The Shape of You\" MBTI event: personality quiz, 16 outfit sets, and NPC bonding tips",
      "excerpt": "\"The Shape of You\" ran in Heartopia from March 13 to April 5, 2026. Take the in-game MBTI personality quiz from the Discover menu to unlock a themed 3-piece outfit and use your result to max out bond with matching NPCs.",
      "author": "amayacrab",
      "tags": [
        "event",
        "mbti",
        "shape of you",
        "outfits",
        "npc bonding"
      ]
    },
    "heartopia-whats-next-party-festival-dave-the-diver": {
      "id": "heartopia-whats-next-party-festival-dave-the-diver",
      "category": "news",
      "date": "2026-07-25",
      "readTimeMinutes": 3,
      "color": "from-cyan-500 to-blue-600",
      "bannerImage": "/locations/whale-sea.webp",
      "title": "What's next in Heartopia: Party Festival is live, and a Dave the Diver collaboration is teased",
      "excerpt": "Heartopia's Party Festival (July 25 – August 31, 2026) brings new \"Party Club\" blueprints for multiplayer play, and the game's official channels have teased an upcoming Heartopia × Dave the Diver collaboration with no confirmed start date yet.",
      "author": "amayacrab",
      "tags": [
        "news",
        "party festival",
        "dave the diver",
        "collaboration teaser"
      ]
    },
    "heartopia-whimsical-tea-party-gilded-acorn": {
      "id": "heartopia-whimsical-tea-party-gilded-acorn",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 4,
      "color": "from-fuchsia-500 to-purple-600",
      "bannerImage": "/icons/misc/spacetime-gacha.webp",
      "title": "Heartopia \"Whimsical Tea Party\" Gilded Acorn Exhibition: outfits, furniture, and pet outfit discount",
      "excerpt": "Tied to the 30-million-download celebration, Heartopia's \"Whimsical Tea Party\" Gilded Acorn Exhibition (April 4, 2026) added Wandering Traveler and Duke Bunny outfits, a Labyrinth furniture set, and a permanent 66.7% discount on original pet outfits.",
      "author": "amayacrab",
      "tags": [
        "event",
        "gilded acorn exhibition",
        "whimsical tea party",
        "pet outfits",
        "furniture"
      ]
    },
    "mlp-event": {
      "id": "mlp-event",
      "category": "event",
      "date": "2026-02-12",
      "readTimeMinutes": 7,
      "color": "from-pink-500 to-purple-600",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × My Little Pony (2026): dates, Tree of Harmony, badges, Rainbow Power exhibitions",
      "excerpt": "Heartopia × My Little Pony runs Feb 7–Mar 25, 2026 (server time). Log in to light up a 7-piece puzzle for a free Spike Pet Costume + 12 Time-Limited Exhibition Passes, then join the Tree of Harmony loop (Elements, Resonance, Watering), collect Souvenir Badges, and pull Rainbow Power exhibitions for Mane 6 outfits and vehicles.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "my-little-pony",
        "tree-of-harmony",
        "elements-of-harmony",
        "souvenir-badges",
        "harmony-energy-gems",
        "exhibition-passes",
        "rainbow-power",
        "vehicles",
        "spike-pet-costume"
      ]
    },
    "pleasant-goat-collab": {
      "id": "pleasant-goat-collab",
      "category": "event",
      "date": "2026-03-20",
      "readTimeMinutes": 5,
      "color": "from-lime-500 to-emerald-600",
      "featured": true,
      "bannerImage": "/events/pleasant-goat/pleasant-goat-cover.webp",
      "title": "Heartopia x Pleasant Goat and Big Big Wolf Event",
      "excerpt": "Heartopia x Pleasant Goat and Big Big Wolf collaboration: Adventure Rally pre-event, reported banners, vehicles, and early rewards.",
      "author": "Heartopia.guide",
      "tags": [
        "event",
        "collaboration",
        "pleasant-goat",
        "adventure-rally",
        "vehicles"
      ]
    },
    "winter-frost-season-fashionwave": {
      "id": "winter-frost-season-fashionwave",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 6,
      "color": "from-blue-500 to-cyan-600",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "Heartopia Winter Frost Season (Fashionwave): Snow, Ice Skating, Rewards, and What Changed",
      "excerpt": "Winter Frost Season (Fashionwave) is live in Heartopia with snow, Ice Skating, daily challenges, event NPCs, seasonal tokens, and limited-time rewards. Read the overview and jump to the full guide.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "winter frost season",
        "fashionwave",
        "winter event",
        "ice skating",
        "onsen mountain",
        "event guide"
      ]
    }
  },
  "pt-BR": {
    "bubbles-day-14-locations": {
      "id": "bubbles-day-14-locations",
      "category": "event",
      "date": "2026-02-14",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubble14/bubble-1-loc.webp",
      "title": "Heartopia: Bubbles do Dia 14 (14 localizações com fotos de minimapa)",
      "excerpt": "As 14 localizações de bubbles do Dia 14 em Heartopia com duas imagens por bubble: close-up (bubble) + foto de minimapa (localização). Sem coordenadas no texto, só referência visual para limpar rápido.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap",
        "day 14"
      ]
    },
    "bubbles-day-7-locations": {
      "id": "bubbles-day-7-locations",
      "category": "event",
      "date": "2026-02-07",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubblesFeb/bubble-7.webp",
      "title": "Heartopia: Bubbles do Dia 7 (14 localizações com minimap)",
      "excerpt": "Localização das 14 bubbles do Dia 7 em Heartopia com imagem + minimap por bubble e um mapa final com todas juntas. Coordenadas ficam ocultas (usadas só no mapa).",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap"
      ]
    },
    "dreamlight-cinematics-festival": {
      "id": "dreamlight-cinematics-festival",
      "category": "event",
      "date": "2026-03-21",
      "readTimeMinutes": 6,
      "color": "from-amber-500 to-rose-600",
      "featured": true,
      "bannerImage": "/events/dreamlight-cinematics/dreamlight-cinematics-week.webp",
      "title": "Dreamlight Cinematics Festival no Heartopia: datas, loja da Azure, catálogo, Saxophone e o que fazer primeiro",
      "excerpt": "Dreamlight Cinematics Festival já está ativo em Heartopia entre 21 de março e 2 de maio de 2026. O evento sazonal atual traz o Dreamlight Cinematics Catalog, Festival Store da Azure, Festival Packs, Saxophone e conteúdo limitado de cooking, fish, insects, birds e wild greens.",
      "author": "amayacrab",
      "tags": [
        "event",
        "dreamlight cinematics festival",
        "azure",
        "massimo",
        "saxophone",
        "limited recipes"
      ]
    },
    "heartopia-30-million-downloads": {
      "id": "heartopia-30-million-downloads",
      "category": "news",
      "date": "2026-04-03",
      "readTimeMinutes": 3,
      "color": "from-emerald-500 to-teal-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Heartopia atinge 30 milhões de downloads — pacote de presente de comemoração explicado",
      "excerpt": "O Heartopia anunciou 30 milhões de downloads em todo o mundo em 3-4 de abril de 2026, com um pacote de presente grátis resgatável até 29 de maio: um Balão Comemorativo 30M, Wishing Stars, Madeira Liuliú, Fluorita Pura e Mermaid Fish Attractors.",
      "author": "amayacrab",
      "tags": [
        "notícia",
        "marco",
        "30 milhões de downloads",
        "recompensas grátis"
      ]
    },
    "heartopia-building-contest-phase-1-winter-frost-home": {
      "id": "heartopia-building-contest-phase-1-winter-frost-home",
      "category": "event",
      "date": "2026-01-30",
      "readTimeMinutes": 5,
      "color": "from-purple-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Heartopia Building Contest (Phase 1): Winter Frost Home — como participar, regras e prêmios",
      "excerpt": "O Heartopia Building Contest (Phase 1) começou com o tema Winter Frost Home. Poste um vídeo (1–2 min) com seu Player ID visível no Discord oficial entre 30/01 e 07/02 e concorra ao prêmio físico Meow-Meow Blind Box.",
      "author": "amayacrab",
      "tags": [
        "event",
        "contest",
        "building",
        "discord",
        "winter-frost-home",
        "limited-time"
      ]
    },
    "heartopia-butterbear-collaboration": {
      "id": "heartopia-butterbear-collaboration",
      "category": "event",
      "date": "2026-06-06",
      "readTimeMinutes": 4,
      "color": "from-amber-400 to-orange-600",
      "bannerImage": "/icons/misc/cooking-misc-hobby.webp",
      "title": "Colaboração Heartopia × Butterbear: decoração de padaria, cookies e o carrinho de urso",
      "excerpt": "Heartopia × Butterbear rodou de 6 a 27 de junho de 2026, trazendo móveis tema padaria, dois banners da Gilded Acorn Exhibition (\"The Baker\", \"Flavor Explorer\") e um veículo andável de carrinho de urso — zerar a loja completa custava, segundo relatos, mais de 7.000 cookies.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "colaboração",
        "butterbear",
        "gilded acorn exhibition",
        "veículos"
      ]
    },
    "heartopia-easter-egg-pact-2026": {
      "id": "heartopia-easter-egg-pact-2026",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 6,
      "color": "from-rose-400 to-amber-500",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "\"My Easter Egg Pact\" do Heartopia: guia de Revival Hymn e Wonder Egg Hunt",
      "excerpt": "A temporada de Páscoa do Heartopia, \"My Easter Egg Pact\", rolou de 4 a 27 de abril de 2026 com dois eventos ao mesmo tempo: Revival Hymn (moeda e receitas baseadas em coleta) e Wonder Egg Hunt (fotografe 8 ovos escondidos na Praça Central por recompensas de ornamento).",
      "author": "amayacrab",
      "tags": [
        "evento",
        "páscoa",
        "revival hymn",
        "wonder egg hunt",
        "receitas limitadas"
      ]
    },
    "heartopia-midsummer-rhyme-dragon-boat": {
      "id": "heartopia-midsummer-rhyme-dragon-boat",
      "category": "event",
      "date": "2026-06-19",
      "readTimeMinutes": 4,
      "color": "from-emerald-600 to-lime-500",
      "bannerImage": "/events/repeatable/start-sea-fishing.webp",
      "title": "\"Midsummer Rhyme\" do Heartopia e o minigame Dryland Dragon Boat Challenge",
      "excerpt": "A referência ao Festival do Barco-Dragão no Heartopia, \"Midsummer Rhyme\", começou em 19 de junho de 2026 com pedidos diários por Astralis's Mugwort Leaves e um novo minigame, o Dryland Dragon Boat Challenge — reme com um parceiro que toca tambor pra restaurar sua energia.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "midsummer rhyme",
        "festival do barco-dragão",
        "minigame",
        "astralis"
      ]
    },
    "heartopia-modular-streets-festival": {
      "id": "heartopia-modular-streets-festival",
      "category": "event",
      "date": "2026-05-09",
      "readTimeMinutes": 5,
      "color": "from-orange-500 to-red-600",
      "bannerImage": "/events/repeatable/bait-the-insects-banner.webp",
      "title": "Modular Streets Festival do Heartopia: como desbloquear peixes, insetos e receitas variante-tijolo",
      "excerpt": "O Modular Streets Festival, estilo LEGO, rodou no Heartopia de 9 de maio a 19 de junho de 2026 — seis semanas de peixes, insetos e pássaros variante-tijolo, além de novas receitas tema Brick, desbloqueado ao capturar uma Libélula e levar até a Azure.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "modular streets festival",
        "azure",
        "receitas limitadas",
        "libélula"
      ]
    },
    "heartopia-oceanbound-call-of-whales-update": {
      "id": "heartopia-oceanbound-call-of-whales-update",
      "category": "update",
      "date": "2026-07-04",
      "readTimeMinutes": 7,
      "color": "from-sky-500 to-blue-700",
      "featured": true,
      "bannerImage": "/locations/whale-mountain.webp",
      "title": "Heartopia 2.7 \"Oceanbound\" / Call of Whales: Whale Canyon, Ocean Cleanup, moradia Seamount e Rory",
      "excerpt": "A atualização de meio de ano do Heartopia, versão 2.7 \"Oceanbound\" (Fashionwave: Call of Whales), começou a ser lançada em 4 de julho de 2026, com o conteúdo principal — novo mapa Whale Canyon, o hobby Ocean Cleanup, a moradia subaquática Seamount e a nova NPC Rory — saindo de 11 de julho a 22 de agosto.",
      "author": "amayacrab",
      "tags": [
        "atualização",
        "oceanbound",
        "call of whales",
        "whale canyon",
        "ocean cleanup",
        "seamount",
        "rory"
      ]
    },
    "heartopia-pets-showcase-x-event-2026": {
      "id": "heartopia-pets-showcase-x-event-2026",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 4,
      "color": "from-pink-500 to-rose-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Evento de Pets do Heartopia no X: como participar, regras e prêmios (02/02–08/02)",
      "excerpt": "O evento de pets no X do Heartopia está no ar: compartilhe fotos/vídeos do seu pet (no jogo ou na vida real), use #heartopia e faça quote/repost do post oficial até 08/02. Três D.G. Members ganham uma Meow-Meow Blind Box.",
      "author": "amayacrab",
      "tags": [
        "event",
        "giveaway",
        "pets",
        "social",
        "x",
        "limited-time",
        "dg-members"
      ]
    },
    "heartopia-sanrio-characters-collaboration": {
      "id": "heartopia-sanrio-characters-collaboration",
      "category": "event",
      "date": "2026-07-17",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × SANRIO CHARACTERS \"Wonderland\": Cinnamoroll, Kuromi, My Melody e a máquina de gacha",
      "excerpt": "Heartopia × SANRIO CHARACTERS' \"Wonderland\" começou em 17 de julho de 2026, com Cinnamoroll, Kuromi e My Melody através de uma Speciality Exhibition, uma Furniture Fair, uma máquina de gacha colocável por jogadores (até 5 giros/dia) e missões diárias de adesivos.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "colaboração",
        "sanrio",
        "cinnamoroll",
        "kuromi",
        "my melody",
        "gacha"
      ]
    },
    "heartopia-shape-of-you-mbti-event": {
      "id": "heartopia-shape-of-you-mbti-event",
      "category": "event",
      "date": "2026-03-13",
      "readTimeMinutes": 5,
      "color": "from-violet-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Evento MBTI \"The Shape of You\" no Heartopia: quiz de personalidade, 16 sets de roupa e dicas de vínculo com NPCs",
      "excerpt": "\"The Shape of You\" rolou no Heartopia de 13 de março a 5 de abril de 2026. Faça o quiz de personalidade MBTI no menu Discover pra desbloquear um outfit temático de 3 peças e use seu resultado pra maximizar o vínculo com NPCs compatíveis.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "mbti",
        "shape of you",
        "outfits",
        "vínculo com npc"
      ]
    },
    "heartopia-whats-next-party-festival-dave-the-diver": {
      "id": "heartopia-whats-next-party-festival-dave-the-diver",
      "category": "news",
      "date": "2026-07-25",
      "readTimeMinutes": 3,
      "color": "from-cyan-500 to-blue-600",
      "bannerImage": "/locations/whale-sea.webp",
      "title": "O que vem por aí no Heartopia: Party Festival no ar, e uma colaboração com Dave the Diver é anunciada",
      "excerpt": "O Party Festival do Heartopia (25 de julho – 31 de agosto de 2026) traz novos blueprints \"Party Club\" pro multiplayer, e os canais oficiais do jogo já teaseram uma futura colaboração Heartopia × Dave the Diver, ainda sem data de início confirmada.",
      "author": "amayacrab",
      "tags": [
        "notícia",
        "party festival",
        "dave the diver",
        "teaser de colaboração"
      ]
    },
    "heartopia-whimsical-tea-party-gilded-acorn": {
      "id": "heartopia-whimsical-tea-party-gilded-acorn",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 4,
      "color": "from-fuchsia-500 to-purple-600",
      "bannerImage": "/icons/misc/spacetime-gacha.webp",
      "title": "Gilded Acorn Exhibition \"Whimsical Tea Party\" do Heartopia: outfits, móveis e desconto de outfit de pet",
      "excerpt": "Ligada à comemoração de 30 milhões de downloads, a Gilded Acorn Exhibition \"Whimsical Tea Party\" do Heartopia (4 de abril de 2026) trouxe os outfits Wandering Traveler e Duke Bunny, o set de móveis Labyrinth e um desconto permanente de 66,7% nos outfits de pet originais.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "gilded acorn exhibition",
        "whimsical tea party",
        "outfits de pet",
        "móveis"
      ]
    },
    "mlp-event": {
      "id": "mlp-event",
      "category": "event",
      "date": "2026-02-12",
      "readTimeMinutes": 7,
      "color": "from-pink-500 to-purple-600",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × My Little Pony (2026): datas, Árvore da Harmonia, emblemas e exibições Rainbow Power",
      "excerpt": "Heartopia × My Little Pony vai de 7 de fev a 25 de mar de 2026 (horário do servidor). Entre todo dia para acender o puzzle de 7 peças e ganhar Spike Pet Costume + 12 Time-Limited Exhibition Passes; depois faça o loop da Árvore da Harmonia (Elementos, Ressonância, Regar), colete Emblemas de Lembrança e puxe as exibições Rainbow Power para roupas e veículos das Mane 6.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "my-little-pony",
        "tree-of-harmony",
        "elements-of-harmony",
        "souvenir-badges",
        "harmony-energy-gems",
        "exhibition-passes",
        "rainbow-power",
        "vehicles",
        "spike-pet-costume"
      ]
    },
    "pleasant-goat-collab": {
      "id": "pleasant-goat-collab",
      "category": "event",
      "date": "2026-03-20",
      "readTimeMinutes": 5,
      "color": "from-lime-500 to-emerald-600",
      "featured": true,
      "bannerImage": "/events/pleasant-goat/pleasant-goat-cover.webp",
      "title": "Evento Heartopia x Pleasant Goat and Big Big Wolf",
      "excerpt": "Heartopia x Pleasant Goat and Big Big Wolf collaboration: Adventure Rally pre-event, reported banners, vehicles, and early rewards.",
      "author": "Heartopia Guide",
      "tags": [
        "event",
        "collaboration",
        "pleasant-goat",
        "adventure-rally",
        "vehicles"
      ]
    },
    "winter-frost-season-fashionwave": {
      "id": "winter-frost-season-fashionwave",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 6,
      "color": "from-blue-500 to-cyan-600",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "Winter Frost Season (Fashionwave) no Heartopia: Neve, Ice Skating, Recompensas e Tudo o Que Mudou",
      "excerpt": "A Winter Frost Season (Fashionwave) chegou ao Heartopia com neve, Ice Skating, desafios diários, loja de tokens, quests e atividades sazonais. Veja o resumo e vá para o guia completo.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "winter frost season",
        "fashionwave",
        "winter event",
        "ice skating",
        "onsen mountain",
        "event guide"
      ]
    }
  },
  "es": {
    "bubbles-day-14-locations": {
      "id": "bubbles-day-14-locations",
      "category": "event",
      "date": "2026-02-14",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubble14/bubble-1-loc.webp",
      "title": "Ubicaciones de las burbujas del Día 14 en Heartopia (14 burbujas con fotos del minimapa)",
      "excerpt": "Las 14 ubicaciones de burbujas del Día 14 en Heartopia con dos imágenes por burbuja: un primer plano de la burbuja y una foto del minimapa/ubicación. Sin coordenadas, solo referencias visuales para una ruta rápida.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap",
        "day 14"
      ]
    },
    "bubbles-day-7-locations": {
      "id": "bubbles-day-7-locations",
      "category": "event",
      "date": "2026-02-07",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubblesFeb/bubble-7.webp",
      "title": "Ubicaciones de las burbujas del Día 7 en Heartopia (14 burbujas con minimapas)",
      "excerpt": "Las 14 ubicaciones de burbujas del Día 7 en Heartopia con una imagen y minimapa por burbuja, además de un mapa final completo. Las coordenadas están ocultas y solo se usan para los marcadores del mapa.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap"
      ]
    },
    "dreamlight-cinematics-festival": {
      "id": "dreamlight-cinematics-festival",
      "category": "event",
      "date": "2026-03-21",
      "readTimeMinutes": 6,
      "color": "from-amber-500 to-rose-600",
      "featured": true,
      "bannerImage": "/events/dreamlight-cinematics/dreamlight-cinematics-week.webp",
      "title": "Dreamlight Cinematics Festival en Heartopia: fechas, tienda de Azure, catálogo, Saxophone y qué hacer primero",
      "excerpt": "Dreamlight Cinematics Festival ya está activo en Heartopia entre el 21 de marzo y el 2 de mayo de 2026. El evento estacional actual trae Dreamlight Cinematics Catalog, Festival Store de Azure, Festival Packs, Saxophone y contenido limitado de cooking, fish, insects, birds y wild greens.",
      "author": "amayacrab",
      "tags": [
        "event",
        "dreamlight cinematics festival",
        "azure",
        "massimo",
        "saxophone",
        "limited recipes"
      ]
    },
    "heartopia-30-million-downloads": {
      "id": "heartopia-30-million-downloads",
      "category": "news",
      "date": "2026-04-03",
      "readTimeMinutes": 3,
      "color": "from-emerald-500 to-teal-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Heartopia alcanza 30 millones de descargas — paquete de regalo de celebración explicado",
      "excerpt": "Heartopia anunció 30 millones de descargas en todo el mundo el 3-4 de abril de 2026, con un paquete de regalo gratuito reclamable hasta el 29 de mayo: un Globo Conmemorativo 30M, Wishing Stars, Madera Liuliú, Fluorita Pura y Mermaid Fish Attractors.",
      "author": "amayacrab",
      "tags": [
        "noticia",
        "hito",
        "30 millones de descargas",
        "recompensas gratis"
      ]
    },
    "heartopia-building-contest-phase-1-winter-frost-home": {
      "id": "heartopia-building-contest-phase-1-winter-frost-home",
      "category": "event",
      "date": "2026-01-30",
      "readTimeMinutes": 5,
      "color": "from-purple-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Heartopia Building Contest (Fase 1): Winter Frost Home — cómo participar, reglas y recompensas",
      "excerpt": "El Heartopia Building Contest (Fase 1) ya está activo con el tema Winter Frost Home. Publica un video de 1 a 2 minutos con tu Player ID visible en el Discord oficial entre el 30 de enero y el 7 de febrero para tener la oportunidad de ganar una Meow-Meow Blind Box física.",
      "author": "amayacrab",
      "tags": [
        "event",
        "contest",
        "building",
        "discord",
        "winter-frost-home",
        "limited-time"
      ]
    },
    "heartopia-butterbear-collaboration": {
      "id": "heartopia-butterbear-collaboration",
      "category": "event",
      "date": "2026-06-06",
      "readTimeMinutes": 4,
      "color": "from-amber-400 to-orange-600",
      "bannerImage": "/icons/misc/cooking-misc-hobby.webp",
      "title": "Colaboración Heartopia × Butterbear: decoración de panadería, cookies y el carrito de oso",
      "excerpt": "Heartopia × Butterbear se desarrolló del 6 al 27 de junio de 2026, trayendo muebles tema panadería, dos banners de la Gilded Acorn Exhibition (\"The Baker\", \"Flavor Explorer\") y un vehículo andante de carrito de oso — despejar la tienda completa costaba, según reportes, más de 7.000 cookies.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "colaboración",
        "butterbear",
        "gilded acorn exhibition",
        "vehículos"
      ]
    },
    "heartopia-easter-egg-pact-2026": {
      "id": "heartopia-easter-egg-pact-2026",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 6,
      "color": "from-rose-400 to-amber-500",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "\"My Easter Egg Pact\" de Heartopia: guía de Revival Hymn y Wonder Egg Hunt",
      "excerpt": "La temporada de Pascua de Heartopia, \"My Easter Egg Pact\", se desarrolló del 4 al 27 de abril de 2026 con dos eventos simultáneos: Revival Hymn (moneda y recetas basadas en recolección) y Wonder Egg Hunt (fotografía 8 huevos escondidos en la Plaza Central por recompensas de ornamento).",
      "author": "amayacrab",
      "tags": [
        "evento",
        "pascua",
        "revival hymn",
        "wonder egg hunt",
        "recetas limitadas"
      ]
    },
    "heartopia-midsummer-rhyme-dragon-boat": {
      "id": "heartopia-midsummer-rhyme-dragon-boat",
      "category": "event",
      "date": "2026-06-19",
      "readTimeMinutes": 4,
      "color": "from-emerald-600 to-lime-500",
      "bannerImage": "/events/repeatable/start-sea-fishing.webp",
      "title": "\"Midsummer Rhyme\" de Heartopia y el minijuego Dryland Dragon Boat Challenge",
      "excerpt": "El homenaje de Heartopia al Festival del Barco Dragón, \"Midsummer Rhyme\", comenzó el 19 de junio de 2026 con pedidos diarios por Astralis's Mugwort Leaves y un nuevo minijuego, el Dryland Dragon Boat Challenge — rema con un compañero que toca el tambor para restaurar tu energía.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "midsummer rhyme",
        "festival del barco dragón",
        "minijuego",
        "astralis"
      ]
    },
    "heartopia-modular-streets-festival": {
      "id": "heartopia-modular-streets-festival",
      "category": "event",
      "date": "2026-05-09",
      "readTimeMinutes": 5,
      "color": "from-orange-500 to-red-600",
      "bannerImage": "/events/repeatable/bait-the-insects-banner.webp",
      "title": "Modular Streets Festival de Heartopia: cómo desbloquear peces, insectos y recetas variante-ladrillo",
      "excerpt": "El Modular Streets Festival, de estilo LEGO, se desarrolló en Heartopia del 9 de mayo al 19 de junio de 2026 — seis semanas de peces, insectos y aves variante-ladrillo, además de nuevas recetas tema Brick, desbloqueado atrapando una Damselfly y llevándola con Azure.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "modular streets festival",
        "azure",
        "recetas limitadas",
        "damselfly"
      ]
    },
    "heartopia-oceanbound-call-of-whales-update": {
      "id": "heartopia-oceanbound-call-of-whales-update",
      "category": "update",
      "date": "2026-07-04",
      "readTimeMinutes": 7,
      "color": "from-sky-500 to-blue-700",
      "featured": true,
      "bannerImage": "/locations/whale-mountain.webp",
      "title": "Heartopia 2.7 \"Oceanbound\" / Call of Whales: Whale Canyon, Ocean Cleanup, vivienda Seamount y Rory",
      "excerpt": "La actualización de medio año de Heartopia, versión 2.7 \"Oceanbound\" (Fashionwave: Call of Whales), comenzó a implementarse el 4 de julio de 2026, con el contenido principal — el nuevo mapa Whale Canyon, el hobby Ocean Cleanup, la vivienda submarina Seamount y la nueva NPC Rory — saliendo del 11 de julio al 22 de agosto.",
      "author": "amayacrab",
      "tags": [
        "actualización",
        "oceanbound",
        "call of whales",
        "whale canyon",
        "ocean cleanup",
        "seamount",
        "rory"
      ]
    },
    "heartopia-pets-showcase-x-event-2026": {
      "id": "heartopia-pets-showcase-x-event-2026",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 4,
      "color": "from-pink-500 to-rose-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Evento de mascotas de Heartopia en X: cómo participar, reglas, fechas y recompensas (2–8 de febrero)",
      "excerpt": "El evento de mascotas de Heartopia en X ya está activo: publica fotos o videos de tu mascota, usa #heartopia y cita o republica la publicación oficial antes del 8 de febrero. Tres D.G. Members ganarán una Meow-Meow Blind Box.",
      "author": "amayacrab",
      "tags": [
        "event",
        "giveaway",
        "pets",
        "social",
        "x",
        "limited-time",
        "dg-members"
      ]
    },
    "heartopia-sanrio-characters-collaboration": {
      "id": "heartopia-sanrio-characters-collaboration",
      "category": "event",
      "date": "2026-07-17",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × SANRIO CHARACTERS \"Wonderland\": Cinnamoroll, Kuromi, My Melody y la máquina de gacha",
      "excerpt": "Heartopia × SANRIO CHARACTERS' \"Wonderland\" comenzó el 17 de julio de 2026, con Cinnamoroll, Kuromi y My Melody a través de una Speciality Exhibition, una Furniture Fair, una máquina de gacha colocable por jugadores (hasta 5 giros/día) y misiones diarias de stickers.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "colaboración",
        "sanrio",
        "cinnamoroll",
        "kuromi",
        "my melody",
        "gacha"
      ]
    },
    "heartopia-shape-of-you-mbti-event": {
      "id": "heartopia-shape-of-you-mbti-event",
      "category": "event",
      "date": "2026-03-13",
      "readTimeMinutes": 5,
      "color": "from-violet-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Evento MBTI \"The Shape of You\" en Heartopia: cuestionario de personalidad, 16 conjuntos de ropa y consejos de vínculo con NPC",
      "excerpt": "\"The Shape of You\" se desarrolló en Heartopia del 13 de marzo al 5 de abril de 2026. Haz el cuestionario de personalidad MBTI en el menú Discover para desbloquear un traje temático de 3 piezas y usa tu resultado para maximizar el vínculo con NPC compatibles.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "mbti",
        "shape of you",
        "trajes",
        "vínculo con npc"
      ]
    },
    "heartopia-whats-next-party-festival-dave-the-diver": {
      "id": "heartopia-whats-next-party-festival-dave-the-diver",
      "category": "news",
      "date": "2026-07-25",
      "readTimeMinutes": 3,
      "color": "from-cyan-500 to-blue-600",
      "bannerImage": "/locations/whale-sea.webp",
      "title": "Qué viene en Heartopia: Party Festival ya está activo, y se anuncia una colaboración con Dave the Diver",
      "excerpt": "El Party Festival de Heartopia (25 de julio – 31 de agosto de 2026) trae nuevos planos \"Party Club\" para el juego multijugador, y los canales oficiales del juego ya han anunciado una próxima colaboración Heartopia × Dave the Diver, sin fecha de inicio confirmada todavía.",
      "author": "amayacrab",
      "tags": [
        "noticia",
        "party festival",
        "dave the diver",
        "adelanto de colaboración"
      ]
    },
    "heartopia-whimsical-tea-party-gilded-acorn": {
      "id": "heartopia-whimsical-tea-party-gilded-acorn",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 4,
      "color": "from-fuchsia-500 to-purple-600",
      "bannerImage": "/icons/misc/spacetime-gacha.webp",
      "title": "Gilded Acorn Exhibition \"Whimsical Tea Party\" de Heartopia: trajes, muebles y descuento de traje de mascota",
      "excerpt": "Ligada a la celebración de 30 millones de descargas, la Gilded Acorn Exhibition \"Whimsical Tea Party\" de Heartopia (4 de abril de 2026) trajo los trajes Wandering Traveler y Duke Bunny, el set de muebles Labyrinth y un descuento permanente del 66,7% en los trajes de mascota originales.",
      "author": "amayacrab",
      "tags": [
        "evento",
        "gilded acorn exhibition",
        "whimsical tea party",
        "trajes de mascota",
        "muebles"
      ]
    },
    "mlp-event": {
      "id": "mlp-event",
      "category": "event",
      "date": "2026-02-12",
      "readTimeMinutes": 7,
      "color": "from-pink-500 to-purple-600",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × My Little Pony (2026): fechas, Tree of Harmony, insignias y exhibiciones Rainbow Power",
      "excerpt": "Heartopia × My Little Pony se celebra del 7 de febrero al 25 de marzo de 2026 (hora del servidor). Inicia sesión para completar un puzzle de 7 piezas y conseguir gratis Spike Pet Costume + 12 Time-Limited Exhibition Passes, luego entra al bucle del Tree of Harmony y a las exhibiciones Rainbow Power.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "my-little-pony",
        "tree-of-harmony",
        "elements-of-harmony",
        "souvenir-badges",
        "harmony-energy-gems",
        "exhibition-passes",
        "rainbow-power",
        "vehicles",
        "spike-pet-costume"
      ]
    },
    "pleasant-goat-collab": {
      "id": "pleasant-goat-collab",
      "category": "event",
      "date": "2026-03-20",
      "readTimeMinutes": 5,
      "color": "from-lime-500 to-emerald-600",
      "featured": true,
      "bannerImage": "/events/pleasant-goat/pleasant-goat-cover.webp",
      "title": "Evento Heartopia x Pleasant Goat and Big Big Wolf",
      "excerpt": "Heartopia x Pleasant Goat and Big Big Wolf collaboration: Adventure Rally pre-event, reported banners, vehicles, and early rewards.",
      "author": "Heartopia Guide",
      "tags": [
        "event",
        "collaboration",
        "pleasant-goat",
        "adventure-rally",
        "vehicles"
      ]
    },
    "winter-frost-season-fashionwave": {
      "id": "winter-frost-season-fashionwave",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 6,
      "color": "from-blue-500 to-cyan-600",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "Heartopia Winter Frost Season (Fashionwave): nieve, Ice Skating, recompensas y cambios",
      "excerpt": "Winter Frost Season (Fashionwave) ya está activo en Heartopia con nieve, Ice Skating, desafíos diarios, NPCs del evento, tokens estacionales y recompensas por tiempo limitado.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "winter frost season",
        "fashionwave",
        "winter event",
        "ice skating",
        "onsen mountain",
        "event guide"
      ]
    }
  },
  "id": {
    "bubbles-day-14-locations": {
      "id": "bubbles-day-14-locations",
      "category": "event",
      "date": "2026-02-14",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubble14/bubble-1-loc.webp",
      "title": "Lokasi gelembung Hari 14 Heartopia (14 gelembung dengan foto minimap)",
      "excerpt": "Seluruh 14 lokasi gelembung Hari 14 di Heartopia dengan dua gambar per gelembung: foto dekat (gelembung) + foto minimap (lokasi). Tanpa koordinat, hanya acuan visual untuk rute yang cepat.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap",
        "day 14"
      ]
    },
    "bubbles-day-7-locations": {
      "id": "bubbles-day-7-locations",
      "category": "event",
      "date": "2026-02-07",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubblesFeb/bubble-7.webp",
      "title": "Lokasi gelembung Hari 7 Heartopia (14 gelembung dengan minimap)",
      "excerpt": "Seluruh 14 lokasi gelembung Hari 7 di Heartopia dengan gambar + minimap per gelembung, plus peta lengkap di akhir. Koordinatnya disembunyikan (hanya dipakai untuk penanda peta).",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap"
      ]
    },
    "dreamlight-cinematics-festival": {
      "id": "dreamlight-cinematics-festival",
      "category": "event",
      "date": "2026-03-21",
      "readTimeMinutes": 6,
      "color": "from-amber-500 to-rose-600",
      "featured": true,
      "bannerImage": "/events/dreamlight-cinematics/dreamlight-cinematics-week.webp",
      "title": "Dreamlight Cinematics Festival di Heartopia: tanggal, toko Azure, katalog, Saxophone, dan apa yang harus dilakukan lebih dulu",
      "excerpt": "Dreamlight Cinematics Festival berlangsung di Heartopia dari 21 Maret sampai 2 Mei 2026. Event musiman ini membawa Dreamlight Cinematics Catalog, Festival Store yang dikelola Azure, Festival Pack, Saxophone, konten memasak terbatas, serta ikan, serangga, burung, dan sayuran liar yang dirilis bertahap.",
      "author": "amayacrab",
      "tags": [
        "event",
        "dreamlight cinematics festival",
        "azure",
        "massimo",
        "saxophone",
        "limited recipes"
      ]
    },
    "heartopia-30-million-downloads": {
      "id": "heartopia-30-million-downloads",
      "category": "news",
      "date": "2026-04-03",
      "readTimeMinutes": 3,
      "color": "from-emerald-500 to-teal-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Heartopia tembus 30 juta unduhan — penjelasan paket hadiah perayaan gratis",
      "excerpt": "Heartopia mengumumkan 30 juta unduhan di seluruh dunia pada 3–4 April 2026, disertai paket hadiah perayaan gratis yang bisa diklaim sampai 29 Mei: Balon Perayaan 30J, Wishing Star, Roaming Oak Timber, Flawless Fluorite, dan Mermaid Fish Attractor.",
      "author": "amayacrab",
      "tags": [
        "news",
        "milestone",
        "30 million downloads",
        "free rewards"
      ]
    },
    "heartopia-building-contest-phase-1-winter-frost-home": {
      "id": "heartopia-building-contest-phase-1-winter-frost-home",
      "category": "event",
      "date": "2026-01-30",
      "readTimeMinutes": 5,
      "color": "from-purple-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Kontes Membangun Heartopia (Fase 1): Winter Frost Home — cara ikut, aturan, dan hadiah",
      "excerpt": "Kontes Membangun Heartopia (Fase 1) sedang berjalan dengan tema Winter Frost Home. Unggah video 1–2 menit dengan Player ID terlihat di Discord resmi antara 30 Januari dan 7 Februari untuk berkesempatan memenangkan Meow-Meow Blind Box fisik.",
      "author": "amayacrab",
      "tags": [
        "event",
        "contest",
        "building",
        "discord",
        "winter-frost-home",
        "limited-time"
      ]
    },
    "heartopia-butterbear-collaboration": {
      "id": "heartopia-butterbear-collaboration",
      "category": "event",
      "date": "2026-06-06",
      "readTimeMinutes": 4,
      "color": "from-amber-400 to-orange-600",
      "bannerImage": "/icons/misc/cooking-misc-hobby.webp",
      "title": "Kolaborasi Heartopia × Butterbear: dekorasi toko roti, kue kering, dan gerobak beruang diner",
      "excerpt": "Heartopia × Butterbear berlangsung 6–27 Juni 2026, membawa perabot bertema toko roti, dua banner Gilded Acorn Exhibition (\"The Baker\" dan \"Flavor Explorer\"), serta kendaraan gerobak beruang diner yang bisa dinaiki — menghabiskan seluruh isi tokonya dilaporkan butuh 7.000+ kue kering.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "butterbear",
        "gilded acorn exhibition",
        "vehicles"
      ]
    },
    "heartopia-easter-egg-pact-2026": {
      "id": "heartopia-easter-egg-pact-2026",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 6,
      "color": "from-rose-400 to-amber-500",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "\"My Easter Egg Pact\" Heartopia: panduan Revival Hymn dan Wonder Egg Hunt",
      "excerpt": "Musim Paskah Heartopia, \"My Easter Egg Pact\", berjalan 4–27 April 2026 dengan dua event sekaligus: Revival Hymn (mata uang dan resep berbasis pengumpulan) dan Wonder Egg Hunt (foto 8 telur tersembunyi di Central Square untuk hadiah ornamen).",
      "author": "amayacrab",
      "tags": [
        "event",
        "easter",
        "revival hymn",
        "wonder egg hunt",
        "limited recipes"
      ]
    },
    "heartopia-midsummer-rhyme-dragon-boat": {
      "id": "heartopia-midsummer-rhyme-dragon-boat",
      "category": "event",
      "date": "2026-06-19",
      "readTimeMinutes": 4,
      "color": "from-emerald-600 to-lime-500",
      "bannerImage": "/events/repeatable/start-sea-fishing.webp",
      "title": "\"Midsummer Rhyme\" Heartopia dan minigame Dryland Dragon Boat Challenge",
      "excerpt": "Perayaan Festival Perahu Naga versi Heartopia, \"Midsummer Rhyme\", dimulai 19 Juni 2026 dengan permintaan harian untuk Astralis's Mugwort Leaves dan minigame baru Dryland Dragon Boat Challenge — mendayunglah bersama rekan yang menabuh genderang untuk memulihkan energimu.",
      "author": "amayacrab",
      "tags": [
        "event",
        "midsummer rhyme",
        "dragon boat festival",
        "minigame",
        "astralis"
      ]
    },
    "heartopia-modular-streets-festival": {
      "id": "heartopia-modular-streets-festival",
      "category": "event",
      "date": "2026-05-09",
      "readTimeMinutes": 5,
      "color": "from-orange-500 to-red-600",
      "bannerImage": "/events/repeatable/bait-the-insects-banner.webp",
      "title": "Modular Streets Festival Heartopia: cara membuka ikan, serangga, dan resep varian brick",
      "excerpt": "Modular Streets Festival bergaya LEGO berjalan di Heartopia dari 9 Mei sampai 19 Juni 2026 — enam minggu berisi ikan, serangga, dan burung varian brick, ditambah resep bertema Brick, yang dibuka dengan menangkap Damselfly dan membawanya ke Azure.",
      "author": "amayacrab",
      "tags": [
        "event",
        "modular streets festival",
        "azure",
        "limited recipes",
        "damselfly"
      ]
    },
    "heartopia-oceanbound-call-of-whales-update": {
      "id": "heartopia-oceanbound-call-of-whales-update",
      "category": "update",
      "date": "2026-07-04",
      "readTimeMinutes": 7,
      "color": "from-sky-500 to-blue-700",
      "featured": true,
      "bannerImage": "/locations/whale-mountain.webp",
      "title": "Heartopia 2.7 \"Oceanbound\" / Call of Whales: Whale Canyon, Ocean Cleanup, hunian Seamount, dan Rory",
      "excerpt": "Update setengah tahun Heartopia, versi 2.7 \"Oceanbound\" (Fashionwave: Call of Whales), bergulir sejak 4 Juli 2026 dengan konten utamanya — peta baru Whale Canyon, hobi Ocean Cleanup, hunian bawah laut Seamount, dan NPC baru Rory — dirilis 11 Juli sampai 22 Agustus.",
      "author": "amayacrab",
      "tags": [
        "update",
        "oceanbound",
        "call of whales",
        "whale canyon",
        "ocean cleanup",
        "seamount",
        "rory"
      ]
    },
    "heartopia-pets-showcase-x-event-2026": {
      "id": "heartopia-pets-showcase-x-event-2026",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 4,
      "color": "from-pink-500 to-rose-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "Event Hewan Peliharaan Heartopia di X: cara ikut, aturan, tanggal, dan hadiah (2–8 Feb)",
      "excerpt": "Event berbagi hewan peliharaan Heartopia berlangsung di X: unggah foto/video hewan peliharaanmu (di dalam game atau dunia nyata), pakai #heartopia, dan quote/repost unggahan resminya sebelum 8 Februari. Tiga D.G. Member masing-masing akan menerima Meow-Meow Blind Box.",
      "author": "amayacrab",
      "tags": [
        "event",
        "giveaway",
        "pets",
        "social",
        "x",
        "limited-time",
        "dg-members"
      ]
    },
    "heartopia-sanrio-characters-collaboration": {
      "id": "heartopia-sanrio-characters-collaboration",
      "category": "event",
      "date": "2026-07-17",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × SANRIO CHARACTERS \"Wonderland\": Cinnamoroll, Kuromi, My Melody, dan mesin gacha-nya",
      "excerpt": "\"Wonderland\" dari Heartopia × SANRIO CHARACTERS dimulai 17 Juli 2026, menampilkan Cinnamoroll, Kuromi, dan My Melody lewat Speciality Exhibition, Furniture Fair, mesin gacha yang bisa dipasang pemain (maksimal 5 putaran/hari), serta misi stiker harian.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "sanrio",
        "cinnamoroll",
        "kuromi",
        "my melody",
        "gacha"
      ]
    },
    "heartopia-shape-of-you-mbti-event": {
      "id": "heartopia-shape-of-you-mbti-event",
      "category": "event",
      "date": "2026-03-13",
      "readTimeMinutes": 5,
      "color": "from-violet-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "Event MBTI \"The Shape of You\" Heartopia: kuis kepribadian, 16 set busana, dan tips ikatan NPC",
      "excerpt": "\"The Shape of You\" berjalan di Heartopia dari 13 Maret sampai 5 April 2026. Ikuti kuis kepribadian MBTI di dalam game lewat menu Discover untuk membuka set busana bertema 3 bagian, dan gunakan hasilnya untuk memaksimalkan ikatan dengan NPC yang cocok.",
      "author": "amayacrab",
      "tags": [
        "event",
        "mbti",
        "shape of you",
        "outfits",
        "npc bonding"
      ]
    },
    "heartopia-whats-next-party-festival-dave-the-diver": {
      "id": "heartopia-whats-next-party-festival-dave-the-diver",
      "category": "news",
      "date": "2026-07-25",
      "readTimeMinutes": 3,
      "color": "from-cyan-500 to-blue-600",
      "bannerImage": "/locations/whale-sea.webp",
      "title": "Apa berikutnya di Heartopia: Party Festival sudah berjalan, dan kolaborasi Dave the Diver mulai digoda",
      "excerpt": "Party Festival di Heartopia (25 Juli – 31 Agustus 2026) membawa cetak biru \"Party Club\" baru untuk bermain bersama, dan kanal resmi game ini menggoda kolaborasi Heartopia × Dave the Diver yang belum punya tanggal mulai.",
      "author": "amayacrab",
      "tags": [
        "news",
        "party festival",
        "dave the diver",
        "collaboration teaser"
      ]
    },
    "heartopia-whimsical-tea-party-gilded-acorn": {
      "id": "heartopia-whimsical-tea-party-gilded-acorn",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 4,
      "color": "from-fuchsia-500 to-purple-600",
      "bannerImage": "/icons/misc/spacetime-gacha.webp",
      "title": "Gilded Acorn Exhibition \"Whimsical Tea Party\" Heartopia: busana, perabot, dan diskon busana hewan peliharaan",
      "excerpt": "Terkait perayaan 30 juta unduhan, Gilded Acorn Exhibition \"Whimsical Tea Party\" di Heartopia (4 April 2026) menambahkan busana Wandering Traveler dan Duke Bunny, set perabot Labyrinth, serta diskon permanen 66,7% untuk busana hewan peliharaan orisinal.",
      "author": "amayacrab",
      "tags": [
        "event",
        "gilded acorn exhibition",
        "whimsical tea party",
        "pet outfits",
        "furniture"
      ]
    },
    "mlp-event": {
      "id": "mlp-event",
      "category": "event",
      "date": "2026-02-12",
      "readTimeMinutes": 7,
      "color": "from-pink-500 to-purple-600",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × My Little Pony (2026): tanggal, Tree of Harmony, lencana, pameran Rainbow Power",
      "excerpt": "Heartopia × My Little Pony berjalan 7 Feb–25 Mar 2026 (waktu server). Login untuk menyalakan teka-teki 7 keping demi Spike Pet Costume gratis + 12 Time-Limited Exhibition Pass, lalu ikuti alur Tree of Harmony (Element, Resonansi, Menyiram), kumpulkan Souvenir Badge, dan tarik pameran Rainbow Power untuk busana dan kendaraan Mane 6.",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "my-little-pony",
        "tree-of-harmony",
        "elements-of-harmony",
        "souvenir-badges",
        "harmony-energy-gems",
        "exhibition-passes",
        "rainbow-power",
        "vehicles",
        "spike-pet-costume"
      ]
    },
    "pleasant-goat-collab": {
      "id": "pleasant-goat-collab",
      "category": "event",
      "date": "2026-03-20",
      "readTimeMinutes": 5,
      "color": "from-lime-500 to-emerald-600",
      "featured": true,
      "bannerImage": "/events/pleasant-goat/pleasant-goat-cover.webp",
      "title": "Event Heartopia x Pleasant Goat and Big Big Wolf",
      "excerpt": "Kolaborasi Heartopia x Pleasant Goat and Big Big Wolf: pra-event Adventure Rally, banner yang dilaporkan, kendaraan, dan hadiah awal.",
      "author": "Heartopia.guide",
      "tags": [
        "event",
        "collaboration",
        "pleasant-goat",
        "adventure-rally",
        "vehicles"
      ]
    },
    "winter-frost-season-fashionwave": {
      "id": "winter-frost-season-fashionwave",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 6,
      "color": "from-blue-500 to-cyan-600",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "Winter Frost Season Heartopia (Fashionwave): salju, seluncur es, hadiah, dan apa yang berubah",
      "excerpt": "Winter Frost Season (Fashionwave) berlangsung di Heartopia dengan salju, seluncur es, tantangan harian, NPC event, token musiman, dan hadiah terbatas waktu. Baca ringkasannya lalu lanjut ke panduan lengkapnya.",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "winter frost season",
        "fashionwave",
        "winter event",
        "ice skating",
        "onsen mountain",
        "event guide"
      ]
    }
  },
  "th": {
    "bubbles-day-14-locations": {
      "id": "bubbles-day-14-locations",
      "category": "event",
      "date": "2026-02-14",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubble14/bubble-1-loc.webp",
      "title": "ตำแหน่งฟองสบู่วันที่ 14 ในเฮิร์ทโทเปีย (14 ฟอง พร้อมภาพมินิแมป)",
      "excerpt": "ตำแหน่งฟองสบู่วันที่ 14 ครบทั้ง 14 จุดในเฮิร์ทโทเปีย พร้อมภาพสองรูปต่อหนึ่งฟอง: ภาพระยะใกล้ (ตัวฟอง) และภาพมินิแมป (ตำแหน่ง) ไม่มีพิกัดตัวเลข มีแค่ภาพอ้างอิงเพื่อวางเส้นทางได้ไว",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap",
        "day 14"
      ]
    },
    "bubbles-day-7-locations": {
      "id": "bubbles-day-7-locations",
      "category": "event",
      "date": "2026-02-07",
      "readTimeMinutes": 5,
      "color": "from-cyan-500 to-teal-600",
      "bannerImage": "/bubblesFeb/bubble-7.webp",
      "title": "ตำแหน่งฟองสบู่วันที่ 7 ในเฮิร์ทโทเปีย (14 ฟอง พร้อมมินิแมป)",
      "excerpt": "ตำแหน่งฟองสบู่วันที่ 7 ครบทั้ง 14 จุดในเฮิร์ทโทเปีย พร้อมรูปภาพและมินิแมปของแต่ละฟอง และแผนที่รวมท้ายบทความ พิกัดตัวเลขถูกซ่อนไว้ (ใช้เฉพาะกับหมุดบนแผนที่)",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "bubbles",
        "bubble locations",
        "pink bubbles",
        "weekly bubbles",
        "rare furniture",
        "rewards",
        "minimap"
      ]
    },
    "dreamlight-cinematics-festival": {
      "id": "dreamlight-cinematics-festival",
      "category": "event",
      "date": "2026-03-21",
      "readTimeMinutes": 6,
      "color": "from-amber-500 to-rose-600",
      "featured": true,
      "bannerImage": "/events/dreamlight-cinematics/dreamlight-cinematics-week.webp",
      "title": "Dreamlight Cinematics Festival ในเฮิร์ทโทเปีย: วันจัดงาน ร้านของ Azure แคตตาล็อก แซกโซโฟน และสิ่งที่ควรทำก่อน",
      "excerpt": "Dreamlight Cinematics Festival เปิดอยู่ในเฮิร์ทโทเปียตั้งแต่วันที่ 21 มีนาคม ถึง 2 พฤษภาคม 2026 อีเวนต์ตามฤดูกาลนี้นำ Dreamlight Cinematics Catalog, Festival Store ที่ดูแลโดย Azure, Festival Pack, แซกโซโฟน, เนื้อหาการทำอาหารแบบจำกัดเวลา และปลา แมลง นก รวมถึงผักป่าที่ทยอยปล่อยเป็นเฟส",
      "author": "amayacrab",
      "tags": [
        "event",
        "dreamlight cinematics festival",
        "azure",
        "massimo",
        "saxophone",
        "limited recipes"
      ]
    },
    "heartopia-30-million-downloads": {
      "id": "heartopia-30-million-downloads",
      "category": "news",
      "date": "2026-04-03",
      "readTimeMinutes": 3,
      "color": "from-emerald-500 to-teal-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "เฮิร์ทโทเปียแตะ 30 ล้านดาวน์โหลด — อธิบายชุดของขวัญฉลองแบบฟรี",
      "excerpt": "เฮิร์ทโทเปียประกาศยอด 30 ล้านดาวน์โหลดทั่วโลกเมื่อวันที่ 3–4 เมษายน 2026 พร้อมชุดของขวัญฉลองที่รับฟรีได้ถึงวันที่ 29 พฤษภาคม ได้แก่ บอลลูนฉลอง 30 ล้าน, ดาวขอพร, ไม้โอ๊กพเนจร, ฟลูออไรต์ไร้ตำหนิ และตัวล่อปลานางเงือก",
      "author": "amayacrab",
      "tags": [
        "news",
        "milestone",
        "30 million downloads",
        "free rewards"
      ]
    },
    "heartopia-building-contest-phase-1-winter-frost-home": {
      "id": "heartopia-building-contest-phase-1-winter-frost-home",
      "category": "event",
      "date": "2026-01-30",
      "readTimeMinutes": 5,
      "color": "from-purple-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "การประกวดสร้างบ้านเฮิร์ทโทเปีย (เฟส 1): Winter Frost Home — วิธีเข้าร่วม กติกา และของรางวัล",
      "excerpt": "การประกวดสร้างบ้านเฮิร์ทโทเปีย (เฟส 1) เปิดแล้วในธีม Winter Frost Home โพสต์วิดีโอความยาว 1–2 นาทีที่เห็น Player ID ชัดเจนในดิสคอร์ดทางการ ระหว่างวันที่ 30 มกราคม ถึง 7 กุมภาพันธ์ เพื่อลุ้นรับ Meow-Meow Blind Box ของจริง",
      "author": "amayacrab",
      "tags": [
        "event",
        "contest",
        "building",
        "discord",
        "winter-frost-home",
        "limited-time"
      ]
    },
    "heartopia-butterbear-collaboration": {
      "id": "heartopia-butterbear-collaboration",
      "category": "event",
      "date": "2026-06-06",
      "readTimeMinutes": 4,
      "color": "from-amber-400 to-orange-600",
      "bannerImage": "/icons/misc/cooking-misc-hobby.webp",
      "title": "คอลแลบ Heartopia × น้องเนย: ของแต่งร้านเบเกอรี่ คุกกี้ และรถเข็นหมีไดเนอร์",
      "excerpt": "Heartopia × น้องเนย จัดระหว่างวันที่ 6–27 มิถุนายน 2026 นำเฟอร์นิเจอร์ธีมเบเกอรี่ แบนเนอร์นิทรรศการ Gilded Acorn สองอัน (\"The Baker\" และ \"Flavor Explorer\") และรถเข็นหมีไดเนอร์ที่ขี่ได้ มีรายงานว่าการกวาดของในร้านให้ครบต้องใช้คุกกี้กว่า 7,000 ชิ้น",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "butterbear",
        "gilded acorn exhibition",
        "vehicles"
      ]
    },
    "heartopia-easter-egg-pact-2026": {
      "id": "heartopia-easter-egg-pact-2026",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 6,
      "color": "from-rose-400 to-amber-500",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "\"My Easter Egg Pact\" ของเฮิร์ทโทเปีย: คู่มือ Revival Hymn และ Wonder Egg Hunt",
      "excerpt": "ซีซันอีสเตอร์ของเฮิร์ทโทเปียในชื่อ \"My Easter Egg Pact\" จัดวันที่ 4–27 เมษายน 2026 พร้อมสองอีเวนต์พร้อมกัน: Revival Hymn (สกุลเงินและสูตรอาหารที่ได้จากการเก็บของ) และ Wonder Egg Hunt (ถ่ายรูปไข่ที่ซ่อนอยู่ 8 ฟองใน Central Square เพื่อรับของแต่งบ้าน)",
      "author": "amayacrab",
      "tags": [
        "event",
        "easter",
        "revival hymn",
        "wonder egg hunt",
        "limited recipes"
      ]
    },
    "heartopia-midsummer-rhyme-dragon-boat": {
      "id": "heartopia-midsummer-rhyme-dragon-boat",
      "category": "event",
      "date": "2026-06-19",
      "readTimeMinutes": 4,
      "color": "from-emerald-600 to-lime-500",
      "bannerImage": "/events/repeatable/start-sea-fishing.webp",
      "title": "\"Midsummer Rhyme\" ของเฮิร์ทโทเปีย และมินิเกม Dryland Dragon Boat Challenge",
      "excerpt": "อีเวนต์เทศกาลเรือมังกรของเฮิร์ทโทเปียในชื่อ \"Midsummer Rhyme\" เริ่มวันที่ 19 มิถุนายน 2026 พร้อมคำขอรายวันเพื่อรับ Astralis's Mugwort Leaves และมินิเกมใหม่ Dryland Dragon Boat Challenge — พายเรือไปพร้อมเพื่อนร่วมทีมที่คอยตีกลองเติมพลังให้คุณ",
      "author": "amayacrab",
      "tags": [
        "event",
        "midsummer rhyme",
        "dragon boat festival",
        "minigame",
        "astralis"
      ]
    },
    "heartopia-modular-streets-festival": {
      "id": "heartopia-modular-streets-festival",
      "category": "event",
      "date": "2026-05-09",
      "readTimeMinutes": 5,
      "color": "from-orange-500 to-red-600",
      "bannerImage": "/events/repeatable/bait-the-insects-banner.webp",
      "title": "Modular Streets Festival ของเฮิร์ทโทเปีย: วิธีปลดล็อกปลา แมลง และสูตรอาหารเวอร์ชันตัวต่อ",
      "excerpt": "Modular Streets Festival สไตล์เลโก้จัดในเฮิร์ทโทเปียตั้งแต่วันที่ 9 พฤษภาคม ถึง 19 มิถุนายน 2026 — หกสัปดาห์ของปลา แมลง และนกเวอร์ชันตัวต่อ พร้อมสูตรอาหารธีมตัวต่อใหม่ ปลดล็อกได้ด้วยการจับ Damselfly แล้วนำไปให้ Azure",
      "author": "amayacrab",
      "tags": [
        "event",
        "modular streets festival",
        "azure",
        "limited recipes",
        "damselfly"
      ]
    },
    "heartopia-oceanbound-call-of-whales-update": {
      "id": "heartopia-oceanbound-call-of-whales-update",
      "category": "update",
      "date": "2026-07-04",
      "readTimeMinutes": 7,
      "color": "from-sky-500 to-blue-700",
      "featured": true,
      "bannerImage": "/locations/whale-mountain.webp",
      "title": "เฮิร์ทโทเปีย 2.7 \"Oceanbound\" / Call of Whales: Whale Canyon, Ocean Cleanup, บ้าน Seamount และ Rory",
      "excerpt": "อัปเดตครบครึ่งปีของเฮิร์ทโทเปีย เวอร์ชัน 2.7 \"Oceanbound\" (Fashionwave: Call of Whales) เริ่มทยอยปล่อยตั้งแต่วันที่ 4 กรกฎาคม 2026 โดยเนื้อหาหลัก — แผนที่ใหม่ Whale Canyon, งานอดิเรก Ocean Cleanup, บ้านใต้ทะเล Seamount และ NPC ใหม่ Rory — ปล่อยระหว่างวันที่ 11 กรกฎาคม ถึง 22 สิงหาคม",
      "author": "amayacrab",
      "tags": [
        "update",
        "oceanbound",
        "call of whales",
        "whale canyon",
        "ocean cleanup",
        "seamount",
        "rory"
      ]
    },
    "heartopia-pets-showcase-x-event-2026": {
      "id": "heartopia-pets-showcase-x-event-2026",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 4,
      "color": "from-pink-500 to-rose-600",
      "bannerImage": "/news/pets-showcase-event.webp",
      "title": "อีเวนต์สัตว์เลี้ยงเฮิร์ทโทเปียบน X: วิธีเข้าร่วม กติกา วันจัดงาน และของรางวัล (2–8 ก.พ.)",
      "excerpt": "อีเวนต์แชร์สัตว์เลี้ยงของเฮิร์ทโทเปียเปิดอยู่บน X: โพสต์รูปหรือวิดีโอสัตว์เลี้ยงของคุณ (ในเกมหรือในชีวิตจริง) ใส่ #heartopia แล้วควตหรือรีโพสต์โพสต์ทางการภายในวันที่ 8 กุมภาพันธ์ D.G. Member 3 คนจะได้รับ Meow-Meow Blind Box คนละกล่อง",
      "author": "amayacrab",
      "tags": [
        "event",
        "giveaway",
        "pets",
        "social",
        "x",
        "limited-time",
        "dg-members"
      ]
    },
    "heartopia-sanrio-characters-collaboration": {
      "id": "heartopia-sanrio-characters-collaboration",
      "category": "event",
      "date": "2026-07-17",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × SANRIO CHARACTERS \"Wonderland\": Cinnamoroll, Kuromi, My Melody และตู้กาชา",
      "excerpt": "อีเวนต์ \"Wonderland\" ของ Heartopia × SANRIO CHARACTERS เริ่มวันที่ 17 กรกฎาคม 2026 นำ Cinnamoroll, Kuromi และ My Melody มาผ่าน Speciality Exhibition, Furniture Fair, ตู้กาชาที่ผู้เล่นวางเองได้ (สูงสุด 5 ครั้งต่อวัน) และเควสต์สติกเกอร์รายวัน",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "sanrio",
        "cinnamoroll",
        "kuromi",
        "my melody",
        "gacha"
      ]
    },
    "heartopia-shape-of-you-mbti-event": {
      "id": "heartopia-shape-of-you-mbti-event",
      "category": "event",
      "date": "2026-03-13",
      "readTimeMinutes": 5,
      "color": "from-violet-500 to-indigo-600",
      "bannerImage": "/news/building-contest-winter-frost-home.webp",
      "title": "อีเวนต์ MBTI \"The Shape of You\" ของเฮิร์ทโทเปีย: แบบทดสอบบุคลิกภาพ ชุดแต่งกาย 16 แบบ และเคล็ดลับเพิ่มความสนิทกับ NPC",
      "excerpt": "\"The Shape of You\" จัดในเฮิร์ทโทเปียตั้งแต่วันที่ 13 มีนาคม ถึง 5 เมษายน 2026 ทำแบบทดสอบบุคลิกภาพแนว MBTI ในเกมจากเมนู Discover เพื่อปลดล็อกชุดแต่งกายตามธีม 3 ชิ้น และใช้ผลลัพธ์เพิ่มความสนิทกับ NPC ที่ตรงกับคุณให้เต็ม",
      "author": "amayacrab",
      "tags": [
        "event",
        "mbti",
        "shape of you",
        "outfits",
        "npc bonding"
      ]
    },
    "heartopia-whats-next-party-festival-dave-the-diver": {
      "id": "heartopia-whats-next-party-festival-dave-the-diver",
      "category": "news",
      "date": "2026-07-25",
      "readTimeMinutes": 3,
      "color": "from-cyan-500 to-blue-600",
      "bannerImage": "/locations/whale-sea.webp",
      "title": "อะไรกำลังจะมาในเฮิร์ทโทเปีย: Party Festival เริ่มแล้ว และมีการปล่อยทีเซอร์คอลแลบ Dave the Diver",
      "excerpt": "Party Festival ของเฮิร์ทโทเปีย (25 กรกฎาคม – 31 สิงหาคม 2026) มาพร้อมพิมพ์เขียว \"Party Club\" ใหม่สำหรับเล่นหลายคน และช่องทางการของเกมได้ปล่อยทีเซอร์คอลแลบ Heartopia × Dave the Diver ที่ยังไม่มีวันเริ่มแน่ชัด",
      "author": "amayacrab",
      "tags": [
        "news",
        "party festival",
        "dave the diver",
        "collaboration teaser"
      ]
    },
    "heartopia-whimsical-tea-party-gilded-acorn": {
      "id": "heartopia-whimsical-tea-party-gilded-acorn",
      "category": "event",
      "date": "2026-04-04",
      "readTimeMinutes": 4,
      "color": "from-fuchsia-500 to-purple-600",
      "bannerImage": "/icons/misc/spacetime-gacha.webp",
      "title": "นิทรรศการ Gilded Acorn \"Whimsical Tea Party\" ของเฮิร์ทโทเปีย: ชุดแต่งกาย เฟอร์นิเจอร์ และส่วนลดชุดสัตว์เลี้ยง",
      "excerpt": "ผูกกับการฉลอง 30 ล้านดาวน์โหลด นิทรรศการ Gilded Acorn \"Whimsical Tea Party\" ของเฮิร์ทโทเปีย (4 เมษายน 2026) เพิ่มชุด Wandering Traveler และ Duke Bunny, เซ็ตเฟอร์นิเจอร์ Labyrinth และส่วนลดถาวร 66.7% สำหรับชุดสัตว์เลี้ยงออริจินัล",
      "author": "amayacrab",
      "tags": [
        "event",
        "gilded acorn exhibition",
        "whimsical tea party",
        "pet outfits",
        "furniture"
      ]
    },
    "mlp-event": {
      "id": "mlp-event",
      "category": "event",
      "date": "2026-02-12",
      "readTimeMinutes": 7,
      "color": "from-pink-500 to-purple-600",
      "featured": true,
      "bannerImage": "/news/mylittlepony-news.webp",
      "title": "Heartopia × My Little Pony (2026): วันจัดงาน Tree of Harmony เข็มกลัด และนิทรรศการ Rainbow Power",
      "excerpt": "Heartopia × My Little Pony จัดวันที่ 7 ก.พ. – 25 มี.ค. 2026 (เวลาเซิร์ฟเวอร์) ล็อกอินเพื่อเปิดจิ๊กซอว์ 7 ชิ้นรับ Spike Pet Costume ฟรี พร้อม Time-Limited Exhibition Pass 12 ใบ จากนั้นเล่นวงจร Tree of Harmony (Element, การสั่นพ้อง, การรดน้ำ) สะสม Souvenir Badge และหมุนนิทรรศการ Rainbow Power เพื่อรับชุดและยานพาหนะของ Mane 6",
      "author": "amayacrab",
      "tags": [
        "event",
        "collaboration",
        "my-little-pony",
        "tree-of-harmony",
        "elements-of-harmony",
        "souvenir-badges",
        "harmony-energy-gems",
        "exhibition-passes",
        "rainbow-power",
        "vehicles",
        "spike-pet-costume"
      ]
    },
    "pleasant-goat-collab": {
      "id": "pleasant-goat-collab",
      "category": "event",
      "date": "2026-03-20",
      "readTimeMinutes": 5,
      "color": "from-lime-500 to-emerald-600",
      "featured": true,
      "bannerImage": "/events/pleasant-goat/pleasant-goat-cover.webp",
      "title": "อีเวนต์ Heartopia x Pleasant Goat and Big Big Wolf",
      "excerpt": "คอลแลบ Heartopia x Pleasant Goat and Big Big Wolf: พรีอีเวนต์ Adventure Rally, แบนเนอร์ที่มีรายงาน, ยานพาหนะ และรางวัลช่วงแรก",
      "author": "Heartopia.guide",
      "tags": [
        "event",
        "collaboration",
        "pleasant-goat",
        "adventure-rally",
        "vehicles"
      ]
    },
    "winter-frost-season-fashionwave": {
      "id": "winter-frost-season-fashionwave",
      "category": "event",
      "date": "2026-02-02",
      "readTimeMinutes": 6,
      "color": "from-blue-500 to-cyan-600",
      "featured": true,
      "bannerImage": "/news/winter-frost-season-banner.webp",
      "title": "Winter Frost Season ของเฮิร์ทโทเปีย (Fashionwave): หิมะ สเก็ตน้ำแข็ง รางวัล และสิ่งที่เปลี่ยนไป",
      "excerpt": "Winter Frost Season (Fashionwave) เปิดแล้วในเฮิร์ทโทเปีย พร้อมหิมะ สเก็ตน้ำแข็ง ภารกิจรายวัน NPC ประจำอีเวนต์ โทเคนตามฤดูกาล และรางวัลแบบจำกัดเวลา อ่านภาพรวมแล้วข้ามไปยังคู่มือฉบับเต็มได้เลย",
      "author": "amayacrab",
      "tags": [
        "heartopia",
        "winter frost season",
        "fashionwave",
        "winter event",
        "ice skating",
        "onsen mountain",
        "event guide"
      ]
    }
  }
};
